/**
 * CMS Edit Mode — postMessage protocol shared with the Bodhisys admin app.
 * Keep in sync with bohdisys-mobile/src/screens/settings/cms/editmode/protocol.ts
 *
 * admin → store : cms:hello, cms:apply, cms:clearDraft, cms:navigate, cms:highlightAll
 * store → admin : cms:ready, cms:route, cms:keys, cms:selected
 */
export const CMS_PROTOCOL_VERSION = 1;

export type CmsFieldType = 'text' | 'textarea' | 'html' | 'image' | 'color' | 'link' | 'checkbox';

export interface CmsEditableKey {
  key: string;
  fieldType: CmsFieldType;
  label?: string;
}

export type AdminToStoreMessage =
  | { v: number; type: 'cms:hello'; brandId?: number; lang?: string }
  | { v: number; type: 'cms:apply'; key: string; value: string }
  | { v: number; type: 'cms:clearDraft'; keys?: string[] }
  | { v: number; type: 'cms:navigate'; path: string }
  | { v: number; type: 'cms:highlightAll'; on: boolean };

export type StoreToAdminMessage =
  | { v: number; type: 'cms:ready'; route: string; keys: CmsEditableKey[] }
  | { v: number; type: 'cms:route'; route: string }
  | { v: number; type: 'cms:keys'; route: string; keys: CmsEditableKey[] }
  | { v: number; type: 'cms:selected'; key: string; fieldType: CmsFieldType; value: string; rect: { top: number; left: number; width: number; height: number } };

/** Distributive Omit — plain Omit collapses a union into its common keys. */
export type DistributiveOmit<T, K extends keyof any> = T extends any ? Omit<T, K> : never;

export const isCmsMessage = (data: any): data is AdminToStoreMessage =>
  !!data && typeof data === 'object' && typeof data.type === 'string' && data.type.startsWith('cms:');
